export default __webpack_public_path__ + "static/media/171.7e237cde.jpg";